import graphqlClient from '~/graphql/graphqlClient';

export type StartInnBattleResult = {
  battle_id: string;
};

const mutation = `
mutation StartInnBattle($battleId: String!) {
  startInnBattle(battleId: $battleId) {
    battle_id
  }
}
`;

export default async function mutationStartInnBattle(
  battleId: string
): Promise<StartInnBattleResult> {
  return await graphqlClient.request<StartInnBattleResult>(
    'startInnBattle',
    mutation,
    { battleId }
  );
}
